import ProductoUpdate from './ProductoUpdate'
export {ProductoUpdate}
export default ProductoUpdate
